import { type FC } from 'react';
import { Paper } from '@mui/material';
import {
  Grid as DevGrid,
  TableHeaderRow,
  VirtualTable
} from '@devexpress/dx-react-grid-material-ui';
import { IntegratedSorting, SortingState } from '@devexpress/dx-react-grid';
import {
  filterLowPercent,
  getLeadPercent,
  leadDemographicColumns
} from '../leadDemographic';
import { LeadDemographicCellComponent } from './LeadDemographicCellComponent';

interface ILeadDemographicTable {
  label: string;
  value: Array<Record<string, string>>;
  columns?: Array<Record<'name' | 'title', string>>;
  rows?: Array<Record<string, string | number>>;
}

export const LeadDemographicTable: FC<ILeadDemographicTable> = ({
  label,
  value,
  columns,
  rows
}) => {
  let tableRows;

  if (rows) {
    tableRows = rows;
  } else {
    tableRows =
      label === 'Insurance Company'
        ? filterLowPercent(getLeadPercent(value))
        : getLeadPercent(value);
  }

  return (
    <Paper>
      <DevGrid
        rows={tableRows}
        columns={columns ?? leadDemographicColumns[label]}
      >
        <SortingState
          defaultSorting={[{ columnName: 'percent', direction: 'desc' }]}
        />
        <IntegratedSorting />
        <VirtualTable
          cellComponent={LeadDemographicCellComponent as never}
          height={300}
        />
        <TableHeaderRow />
      </DevGrid>
    </Paper>
  );
};
